module.exports = __webpack_public_path__ + "static/media/CI_prospective.8ee005d1.jpg";